"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _productHelper = require("../../../../../helpers/productHelper");
var _VerificationRequiredContainer = _interopRequireDefault(require("../../../../VerificationRequired/VerificationRequiredContainer"));
var _productPositionSelectors = require("../../../../../redux/selectors/productPositionSelectors");
var _buySellSelectors = require("../../../../../redux/selectors/buySellSelectors");
var _instrumentPositionSelectors = require("../../../../../redux/selectors/instrumentPositionSelectors");
var _BuySellOrderButtonComponent = _interopRequireDefault(require("./BuySellOrderButtonComponent"));
var _instrumentPositionSelectors2 = require("../../../../../../lib/redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var isBuySide = (0, _buySellSelectors.isBuySideBuySellFormSelector)(state);
  var tradingDisabled = (0, _buySellSelectors.tradingDisabledSelector)(state);
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var product1 = (0, _productPositionSelectors.getProductByIdSelector)(state, selectedInstrument.Product1);
  var product2 = (0, _productPositionSelectors.getProductByIdSelector)(state, selectedInstrument.Product2);
  var product1Name = (0, _productHelper.getProductFullName)(product1);
  var product2Name = (0, _productHelper.getProductFullName)(product2);
  var isCustomAmount = (0, _instrumentPositionSelectors2.buySellFormSelector)(state, 'amountRadio') === 'custom';
  var customAmount = (0, _instrumentPositionSelectors2.buySellFormSelector)(state, 'price');
  var disabled = tradingDisabled || isCustomAmount && !customAmount;
  return {
    disabled: disabled,
    isBuySide: isBuySide,
    VerificationRequiredComponent: _VerificationRequiredContainer["default"],
    product1Name: product1Name,
    product2Name: product2Name
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_BuySellOrderButtonComponent["default"]);